import CalendarInput from 'components/CalendarInput/CalendarInput'
import { HonestSelectInput } from 'components/HonestSelect/HonestSelectInput'
import { Input } from 'components/Input/Input'
import { CloseIcon } from 'assets/icons/CloseIcon'
import { Flex, PageFooter } from 'styling/GlobalStyles'
import { OtherText, TitleText } from 'styling/Typography'
import { tokens } from 'styling/tokens'
import { IconContainer, SearchField } from '../Accommodation.style'
import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from 'store'
import { WhitePersonIcon } from '../icons/WhitePersonIcon'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import { Pagination } from 'components/Pagination/Pagination'
import { useEffect, useState } from 'react'
import { getBedsHistory } from 'features/accommodation/accommodationSlice'
import { ISelectValue } from 'constants/globalTypes'

const personName = (bed: any) =>
    bed.user
        ? `${bed.user.firstName} ${bed.user.lastName}`
        : `${bed.accommodationGuest?.firstName || ''} ${bed.accommodationGuest?.lastName || ''}`

export const BedHistory = () => {
    const [params, setParams] = useState(getParams({ location, limit: 30 }))
    const [search, setSearch] = useState('')
    const { bedsHistory } = useSelector((state: RootState) => state.accomodation)
    const dispatch = useDispatch<AppDispatch>()

    const query = search.trim().toLowerCase()
    const rows = query
        ? bedsHistory.data.filter((bed) => personName(bed).toLowerCase().includes(query))
        : bedsHistory.data

    const NoBeds = () => {
        return <Flex center justcenter height='100%' column gap='1rem' >
            <IconContainer>
                <WhitePersonIcon />
            </IconContainer>
            <TitleText>No History Available for selected filters</TitleText>
        </Flex>
    }

    useEffect(() => {
        dispatch(getBedsHistory(params))
    }, [params])

    const columns: IHonestTableColumn<any>[] = [
        {
            id: 'person',
            header: 'Person',
            cell: (bed) => (
                <Flex column gap='0.5rem' >
                    <TitleText>{bed.user ? (bed.user.firstName + ' ' + bed.user.lastName) : (bed.accommodationGuest?.firstName + ' ' + bed.accommodationGuest?.lastName)}</TitleText>
                    <OtherText grey>ID: {bed.accommodationGuest ? bed.accommodationGuest?.identificationNumber : bed.user?.id}</OtherText>
                </Flex>
            ),
        },
        {
            id: 'type',
            header: 'Type',
            cell: (bed) => <StatusPill status={bed.personType == 1 ? 'info' : 'neutral'}>{bed.personType == 1 ? 'Employee' : 'Guest'}</StatusPill>,
        },
        { id: 'bed', header: 'Bed', cell: (bed) => <TitleText>{bed?.bed?.label}</TitleText> },
        { id: 'location', header: 'Location', cell: (bed) => <TitleText>{bed?.campName} / {bed?.blockName} / {bed?.roomName}</TitleText> },
        { id: 'checkIn', header: 'Check-In', cell: (bed) => <TitleText>{formatDateForDisplay(bed.checkInTimestamp)}</TitleText> },
        {
            id: 'checkOut', header: 'Check-Out', cell: (bed) => {
                if (bed.actualCheckOutTimestamp) {
                    const late = bed.expectedCheckOutTimestamp && new Date(bed.actualCheckOutTimestamp) > new Date(bed.expectedCheckOutTimestamp)
                    return (
                        <Flex column gap='0.15rem'>
                            <TitleText>{formatDateForDisplay(bed.actualCheckOutTimestamp)}</TitleText>
                            {late
                                ? <OtherText color={tokens.status.danger.fg}>Overstayed · due {formatDateForDisplay(bed.expectedCheckOutTimestamp)}</OtherText>
                                : <OtherText grey>Checked out</OtherText>}
                        </Flex>
                    )
                }
                const overdue = bed.expectedCheckOutTimestamp && new Date(bed.expectedCheckOutTimestamp) < new Date()
                return (
                    <Flex column gap='0.15rem'>
                        <TitleText>{formatDateForDisplay(bed.expectedCheckOutTimestamp)}</TitleText>
                        {overdue
                            ? <OtherText color={tokens.status.danger.fg}>Expected · overdue</OtherText>
                            : <OtherText grey>Expected</OtherText>}
                    </Flex>
                )
            },
        },
        { id: 'checkOverride', header: 'Check-Override', cell: (bed) => <TitleText>{bed?.overrideReason ? 'YES' : 'NO'}</TitleText> },
    ]

    return <Flex column gap='1rem' >

        <Flex gap='1rem' >
            <CalendarInput width='250px' labelText='Date From' nomarg defaultValue={params.dateFrom ? new Date(params.dateFrom) : null} onChange={d => setParams(prev => ({ ...prev, dateFrom: d }))} maxDate={params.dateTo ? new Date(params.dateTo) : null} />
            <CalendarInput width='250px' labelText='Date To' nomarg defaultValue={params.dateTo ? new Date(params.dateTo) : null} onChange={d => setParams(prev => ({ ...prev, dateTo: d }))} minDate={params.dateFrom ? new Date(params.dateFrom) : null} />
            {/* <HonestSelectInput onChange={null} options={[]} labelText='Camp' />
                <HonestSelectInput onChange={null} options={[]} labelText='Block' /> */}
            <HonestSelectInput width='250px' nomarg defaultValue={params.personType} onChange={(v: ISelectValue) => setParams(prev => ({ ...prev, personType: v.value }))} options={[{ label: 'Employee', value: 1 }, { label: 'Guest', value: 2 }]} labelText='Person Type' />
            <SearchField>
                <Input search nomarg width='250px' labelText='Search' placeholder='Search by name' value={search} onChange={(e) => setSearch(e.target.value)} rightIcon={search ? <CloseIcon /> : null} onRightIconClick={search ? () => setSearch('') : undefined} />
            </SearchField>
        </Flex>
        {rows.length === 0 ? <NoBeds /> : <HonestTable columns={columns} data={rows} keyField='id' />}
        {!query && (
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(bedsHistory.totalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        )}

    </Flex >
}